import { render, staticRenderFns } from "./loadingScreen.vue?vue&type=template&id=e252f4de&"
import script from "./loadingScreen.vue?vue&type=script&lang=ts&"
export * from "./loadingScreen.vue?vue&type=script&lang=ts&"
import style0 from "./loadingScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports